var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode && (_vm.mode == 'clone' || _vm.mode == 'edit' ||_vm.mode == 'new'))?_c('span',{class:_vm.show ? 'red--text' : 'transparent--text d-none d-lg-inline'},[_vm._v("*")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }